import { LogoMark } from "./Logo";

const ITEMS = [
  { t: "Ascoltami su Spotify", outline: false },
  { t: "sfushop drop 01", outline: true },
  { t: "Musica senza filtri", outline: false },
  { t: "InkMaster — impara a tatuare, in arrivo", outline: true },
  { t: "Stile senza regole", outline: false },
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((it) => (
      <span key={it.t} className="flex items-center">
        <span className={`whitespace-nowrap px-8 font-display text-5xl font-black uppercase tracking-tight sm:text-7xl lg:text-8xl ${it.outline ? "text-outline" : "text-bone"}`}>
          {it.t}
        </span>
        <LogoMark className="h-12 w-12 shrink-0 sm:h-16 sm:w-16" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-line bg-ink-2 py-10 lg:py-14">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
